import { jsx as _jsx } from "react/jsx-runtime";
import { FieldTimeOutlined } from "@ant-design/icons";
import { observer } from "mobx-react";
import { AffiliateStatePanel } from "./affiliateStatePanel.js";
import { __ } from "../../../../../../utils/i18n.js";
const AffiliateSignupPendingState = observer(()=>/*#__PURE__*/ _jsx(AffiliateStatePanel, {
        tone: "primary",
        icon: /*#__PURE__*/ _jsx(FieldTimeOutlined, {}),
        heading: __("We're reviewing your application"),
        children: __("This usually takes three business days. We'll email you once your affiliate account is ready.")
    }));
export { AffiliateSignupPendingState };
